import { Component, ElementRef, Inject, NgZone, PLATFORM_ID, TransferState } from '@angular/core';

import {
  DxAccordionComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';

@Component({
  selector: 'abc-accordion',
  template: '',
  standalone: true,
  providers: [DxTemplateHost, WatcherHelper, IterableDifferHelper, NestedOptionHost]
})
export class AbcAccordionComponent extends DxAccordionComponent {
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, _idh, optionHost, transferState, platformId);
  }
}
